import React from 'react'
import styles from './SpoeumModal.module.scss'

/**
 * 범용 확인 모달 컴포넌트
 * @param {Function} onClose - 취소/닫기 핸들러
 * @param {Function} onConfirm - 확인/수락 핸들러
 * @param {string|ReactNode} title - 모달 제목
 * @param {string|ReactNode} detail - 모달 상세 내용 (span 등 복잡한 JSX 가능)
 * @param {string} confirmButtonText - 확인 버튼 텍스트 (기본값: '확인')
 * @param {string} cancelButtonText - 취소 버튼 텍스트 (기본값: '취소')
 * @param {boolean} hideCancelButton - 취소 버튼 숨기기 (기본값: false, true일 때 확인 버튼만 전체 너비로 표시)
 */
const SpoeumModal = ({
	onClose,
	onConfirm,
	title,
	detail,
	confirmButtonText = '확인',
	cancelButtonText = '취소',
	hideCancelButton = false,
}) => {
	return (
		<div className={styles.modalOverlay} onClick={onClose}>
			<div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
				<span className={styles.title}>{title}</span>
				<span className={styles.detail}>{detail}</span>
				<div
					className={`${styles.button_container} ${
						hideCancelButton ? styles.singleButton : ''
					}`}>
					{!hideCancelButton && (
						<button className={styles.cancelButton} onClick={onClose}>
							{cancelButtonText}
						</button>
					)}
					<button
						className={`${styles.confirmButton} ${
							hideCancelButton ? styles.fullWidthButton : ''
						}`}
						onClick={onConfirm || onClose}>
						{confirmButtonText}
					</button>
				</div>
			</div>
		</div>
	)
}

export default SpoeumModal
